document.addEventListener('DOMContentLoaded', function () {
  const bp = document.querySelector('blog-posts[data-tag="銀河高原ビール"]');
  if (!bp) return;

  const blog  = bp.dataset.blog;
  const limit = parseInt(bp.dataset.limit) || 3;
  const showCategory = bp.dataset.showCategory === 'true';
  const showExcerpt  = bp.dataset.showExcerpt  === 'true';
  const showReadMore = bp.dataset.showReadMore  === 'true';

  // Liquid が部分的に描画済みの場合もクリアして API で再描画
  bp.innerHTML = '';

  fetch('/blogs/' + blog + '?view=ginga-api')
    .then(function (r) { return r.json(); })
    .then(function (articles) {
      articles.slice(0, limit).forEach(function (article) {
        bp.insertAdjacentHTML('beforeend', buildCard(article, showCategory, showExcerpt, showReadMore));
      });
    })
    .catch(function (e) { console.error('blog-posts-ginga:', e); });

  function buildCard(article, showCat, showEx, showRM) {
    var imgHtml = article.image
      ? '<a href="' + article.url + '" class="overflow-hidden"><img src="' + article.image + '" class="blog-post-card__image w-full" loading="lazy"></a>'
      : '';

    var catHtml = '';
    if (showCat && article.tags && article.tags.length > 0) {
      var tag = article.tags[0];
      catHtml = '<a href="' + article.blog_url + '/tagged/' + encodeURIComponent(tag) + '" class="link-faded">' + tag + '</a>';
    }

    var excerptHtml = '';
    if (showEx && article.excerpt) {
      excerptHtml = '<p class="blog-post-card__excerpt">' + article.excerpt + '</p>';
    }

    var readMoreHtml = showRM
      ? '<a href="' + article.url + '" class="blog-post-card__read-more link">続きを読む</a>'
      : '';

    return '<div class="blog-post-card group snap-center">'
      + imgHtml
      + '<div class="blog-post-card__info">'
      + '<div class="blog-post-card__category">'
      + '<span class="info-date">' + article.date + '</span>'
      + catHtml
      + '</div>'
      + '<p><a href="' + article.url + '" class="blog-post-card__title h4">' + article.title + '</a></p>'
      + excerptHtml
      + readMoreHtml
      + '</div>'
      + '</div>';
  }
});
